import { render, staticRenderFns } from "./EditarCategoriaModal.vue?vue&type=template&id=5bd06a72&"
import script from "./EditarCategoriaModal.vue?vue&type=script&lang=js&"
export * from "./EditarCategoriaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports